import React from 'react'
import compose from 'recompose/compose'
import { inject, observer } from 'mobx-react'
import { FormattedMessage } from 'react-intl'
import { Icon, Tag } from 'antd'
import moment from 'moment'
import _get from 'lodash/get'
import localeGet from '~/App/utils/localeGet'
import './styles.css'
import LazyLoad from 'react-lazyload'
import withClientId from '~/App/hocs/withClientId'

// const clientId = process.env.REACT_APP_CLIENT_ID

export default compose(
  inject('i18n'),
  observer,
  withClientId
)((props) => {
  const {
    slug,
    legacy,
    website,
    name,
    startDate,
    endDate,
    hideDate,
    testMode,
    isSoldOut,
    thumbnailUrl,
    location,
    whiteLabelUrl,
    i18n: { locale },
    settings,
    isRegOpen,
    history,
    isBeforeEndPeriods,
    clientId
  } = props
  const toDay = (time) => {
    return moment(time).format('DD')
  }
  const toMonth = (time) => {
    return moment(time).format('MMM')
  }
  const toDayMonth = (time) => {
    return moment(time).format('DD MMM')
  }
  const dateBlock = ({startDate, endDate}) => {
    let raceDate = ''
    if (toDayMonth(startDate) === toDayMonth(endDate)) {
      raceDate = toDayMonth(startDate)
    } else if (toMonth(startDate) === toMonth(endDate)) {
      raceDate = `${toDay(startDate)}~${toDay(endDate)} ${toMonth(startDate)}`
    } else {
      raceDate = `${toDayMonth(startDate)}${endDate ? `~${toDayMonth(endDate)}` : ''}`
    }
    return <div className="raceDateBox">
      <Icon type="calendar" />
      {raceDate}
    </div>
  }
  const isVirtual = !!_get(settings, 'virtualRun', false)
  let vrBlock = ''
  if (isVirtual) {
    const vrStart = settings.virtualRun.period.start
    const vrEnd = settings.virtualRun.period.end
    vrBlock = (<div className="innerScheduleRaceBlock">
      <div className="raceLocationBox">
        <Icon type="global" className="vr" />
        <FormattedMessage id="app.vrRun" defaultMessag="Register" />
      </div>
      {dateBlock({startDate: vrStart, endDate: vrEnd})}
    </div>)
  }
  const normalRaceBlock = !hideDate && <div className={`innerScheduleRaceBlock`}>
    <div className="raceLocationBox">
      <Icon type="environment" className="location" />
      {!location && <FormattedMessage id="app.raceLocation"/>}
      {location && location}
    </div>
    {dateBlock({startDate, endDate})}
  </div>
  const handleRedirection = () => {
    if (legacy && website) {
      window.open(website, '_blank').focus()
    } else if (!whiteLabelUrl || clientId) {
      window.scrollTo(0, 0)
      history.push(`/${slug}`)
    } else {
      window.open(whiteLabelUrl, '_blank').focus()
    }
  }
  const dividerBlock = !hideDate && isVirtual && <div className="dividerBlock"></div>
  const regTag = () => {
    if (isRegOpen) {
      if (isSoldOut) {
        return <Tag color="red">
          <FormattedMessage id="app.soldOut" defaultMessag="Sold Out" />
        </Tag>
      }
      return <Tag color="green">
        <FormattedMessage id="app.enabledRegister" defaultMessag="Register" />
      </Tag>
    } else {
      if (isBeforeEndPeriods) {
        return <Tag className="notOpenReg">
          <FormattedMessage id='app.regUpcoming2' />
        </Tag>
      } else {
        return <Tag color="gray">
          <FormattedMessage id='app.regClosed2' />
        </Tag>
      }
    }
  }
  return (
    <div className="eventCardBox" onClick={handleRedirection}>
      <div className="eventCard">
        <div className="eventCardImgWrapper">
          <LazyLoad height={200}>
            <img className="eventCardImg" src={thumbnailUrl} alt="" />
          </LazyLoad>
        </div>
        <div className="eventRegStatusTags">
          {(!whiteLabelUrl || clientId)
            ? regTag()
            : <Tag color="#f50">
              <FormattedMessage id="app.enabledRegister" defaultMessag="Register" />
            </Tag>
          }
          {website &&
            <Tag color="#2db7f5">
              Website
            </Tag>}
          {testMode &&
            <Tag color="red">
              Test mode !!!
            </Tag>}
        </div>
        <div className="eventName">
          {localeGet(name, '', locale)}
        </div>
        <div className="scheduleRaceBlock">
          {normalRaceBlock}{dividerBlock}
          {vrBlock}
        </div>
      </div>
    </div>
  )
})



// WEBPACK FOOTER //
// ./src/App/EventListPage/EventItem/EventItem.js